module.exports = __webpack_public_path__ + "static/media/am_ticket_inactive.1ea311a0.svg";